import React, { Component } from 'react';
import './About.css';
import '../App.scss'
import eyes from '../footer/img/eyes.svg';
import { modalWindows } from 'src/actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Mixpanel } from '../Mixpanel';

const CardHint = (props) =>(
  <div className="btn btn_1" onClick={props.onHintClick}>
    <div className="text">{props.text1} — <br/>{props.text2}</div>
    <div className="arrow-right"></div>
  </div>
)

CardHint.propTypes = {
  text1: PropTypes.string.isRequired,
  text2: PropTypes.string.isRequired,
  onHintClick: PropTypes.func.isRequired,
}

class About extends Component {
  state = {
    counterAll: 10000,
    counterTelegram: 4600,
    counterVk: 4700,
    counterRhackers: 1620,
    newCards: [{
        id: 1,
        text1: 'Я',
        text2: 'хакер',
        onHintClick: () => this.props.openHacker(),
      }, {
        id: 2,
        text1: 'Я',
        text2: 'организатор',
        onHintClick: () => this.props.openOrganizer(),
      }, {
        id: 3,
        text1: 'Мы',
        text2: 'компания',
        onHintClick: () => this.props.openCompany(),
      }]
  }

  componentDidMount() {
    Mixpanel.track('Page about');
  }


  render() {
    return (
      <div className='about'>
        <div className='title'>Russian Hackers</div>
        <div className="subtitle">Мы меняем хакатоны в России!</div>
        <div className="about-part">
        <div className="about-part_left">
          <img src={eyes} alt="eyes"/>
          <p className="about-text about-tex_left">Уже сейчас</p>
          <p className="about-text about-tex_left">мы объединяем</p>
          <p className="about-text about-tex_left">более {this.state.counterAll} хакеров</p>
          <div className="counter counter_tele">
            {this.state.counterTelegram}<br/>telegram
          </div>
          <div className="dot-separator"/>
          <div className="counter counter_vk">
            {this.state.counterVk}<br />vk.com</div>
          <div className="dot-separator dot-separator_reverse"/>
          <div className="counter counter_rhackers">
            {this.state.counterRhackers}<br/>rhackers</div>
        </div>
        <div className="about-part_right">
          <p className="about-text about-text_1">
            <i>Хакатон</i> — это командное соревнование разработчиков, продактов и вспомогательных специалистов для создания клевых прототипов и инноваций.
            <br/>
            <br/>
            Хакатоны во всем мире объединяют одна, самая главная вещь без которых они не могут сущестовать - их участники. Мы комьюнити участников хакатонов, помогаем творить и побеждать.
          </p>
          <div className="btns-wrapper">
            {
          this.state.newCards.map((newCard, i) => {
            return (
              <CardHint
                key={newCard.id}
                text1={newCard.text1}
                text2={newCard.text2}
                onHintClick={newCard.onHintClick}
              />
            )
          })
        }
          </div>
          <p className="about-text about-text_2">
            Russianhackers.org — это платформа, которая призвана объединить участников хакатонов, организаторов, и компании, которые хотят поддержать это движение в том виде, как его видим мы. Это позволит  и развивать наше комьюнити и развиваться всем, кто в него входит.<br/><br/>
            Поехали!
          </p>
          <h3 className="partners">Партнеры</h3>
          <div className="partners-logos">
            <img className="partners-logo" src={require("./img/here.svg")} alt="HERE" />
            <img className="partners-logo" src={require("./img/cleverbots.svg")} alt="Cleverbots" />
            <img className="partners-logo" src={require("./img/github.svg")} alt="Github" />
            <img className="partners-logo" src={require("./img/mlh.svg")} alt="MLH" />
            <img className="partners-logo" src={require("./img/etc.svg")} alt="ETC" />
            <img className="partners-logo" src={require("./img/rb.svg")} alt="Rusbase" />
          </div>
        </div>
        </div>
      </div>
    );
  }
}


About.propTypes = {
  openCompany: PropTypes.func.isRequired,
  openHacker: PropTypes.func.isRequired,
  openOrganizer: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {};
}


export default withRouter(
  connect(mapStateToProps, {
    openCompany: modalWindows.openCompany,
    openHacker: modalWindows.openHacker,
    openOrganizer: modalWindows.openOrganizer,
  })(About)
);


// WEBPACK FOOTER //
// ./src/components/About/About.js